import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Viewerlayer } from "../../model/viewerlayer";
import { ViewerConstants } from "../../../shared/model/viewer-constants";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-overlay-layer-item",
  templateUrl: "./overlay-layer-item.component.html",
  styleUrls: ["./overlay-layer-item.component.scss"],
  standalone: false,
})
export class OverlayLayerItemComponent implements OnInit {
  _layer: Viewerlayer;

  sources = ViewerConstants.SOURCE_NAME;

  @Input() set layer(layer: Viewerlayer) {
    this._layer = layer;
  }

  @Input()
  filterLayer: string;

  @Input()
  filterField: string;

  get layer(): Viewerlayer {
    return this._layer;
  }

  @Output() changeVisibilityEvent = new EventEmitter<{
    layer: Viewerlayer;
    visibility: boolean;
  }>();

  @Output() changeChildVisibilityEvent = new EventEmitter<{
    layer: Viewerlayer;
    child: Viewerlayer;
    visibility: boolean;
  }>();

  @Output() editLayerEvent = new EventEmitter<string>();

  @Output() removeLayerEvent = new EventEmitter<string>();

  @Output() fitEvent = new EventEmitter<any>();

  @Output() fitFeatureEvent = new EventEmitter<{
    layer: Viewerlayer;
    feature: any;
  }>();

  @Output() retrieveDamageAssessmentEvent = new EventEmitter<Viewerlayer>();

  @Output() retrievePropertyInformationEvent = new EventEmitter<Viewerlayer>();

  ngOnInit(): void {}

  changeVisibility(event: MatCheckboxChange) {
    this.changeVisibilityEvent.emit({
      layer: this._layer,
      visibility: event.checked,
    });
  }

  changeChildVisibility(event: MatCheckboxChange, child: Viewerlayer) {
    this.changeChildVisibilityEvent.emit({
      layer: this._layer,
      visibility: event.checked,
      child,
    });
  }

  editLayer() {
    this.editLayerEvent.emit(this._layer.id);
  }

  removeLayer() {
    this.removeLayerEvent.emit(this._layer.id);
  }

  fit() {
    const fitOptions = {
      padding: [10, 10, 10, 10],
      duration: 0,
    };
    const extent = { bbox: this._layer.bbox, fitOptions };
    this.fitEvent.emit(extent);
  }

  fitFeature(feat: any) {
    this.fitFeatureEvent.emit({ layer: this.layer, feature: feat });
  }

  checkEditAvailable() {
    return (
      [
        this.sources.WFS,
        this.sources.VECTOR,
        this.sources.VECTORTILES,
        this.sources.ARCGISFEATURE,
        this.sources.WMS,
        this.sources.WMTS,
      ].includes(this._layer.sourceName) && this.layer.owner
    );
  }

  inderterminate() {
    let childLayers = this.layer.layersAvailable ? this.layer.layersAvailable : null;

    if (!childLayers) childLayers = this.layer.childs ? this.layer.childs : null;

    return this.layer.visible && childLayers?.length !== childLayers?.filter((c) => c.visible).length;
  }

  expandCard(layer) {
    layer.cardExpansed = !layer.cardExpansed;
  }

  checkDamageAssessmentAvailable() {
    return this.layer.overlayType === "csv";
  }

  retrieveDamageAssessment() {
    this.retrieveDamageAssessmentEvent.emit(this.layer);
  }

  retrievePropertyInformation() {
    this.retrievePropertyInformationEvent.emit(this.layer);
  }
}
